module.exports = __webpack_public_path__ + "img/00035.54b8635d.webp";